module.exports = __webpack_public_path__ + "assets/img/Logitech-Workspace-w720.017cdd93.webp";